import { useQueryDownloader } from '@trinity/chat-components/containers/QueryDownloader/hooks/index';

type Params = {
  kol: {
    id: number | string;
    name: string;
  };
};

export const useDownloadKolProfile = (params: Params) => {
  return useQueryDownloader({
    queryKey: [`kol-profile:download`, params.kol.id],
    queryFn: ({ queryKey: [, kolId] }) => {
      throw new Error(`Not implemented`);
    },
    meta: {
      downloader: true,
    },
    downloaderOptions: {
      // onResponse: (res) => ({
      //   filename: `HCP 360 Profile: ${params.kol.name}.docx`,
      //   type: 'blob',
      //   value: res.data,
      // }),
    },
  });
};
